export const getApiEnvConfig = () => ({
    url: 'core/v4/system/config',
    method: 'get',
});
